import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';
import './Dashboard.css';

const STATUS_LABEL = {
  pending: 'Menunggu Review',
  approved: 'Disetujui',
  rejected: 'Ditolak',
};

export default function Dashboard() {
  const navigate = useNavigate();
  const artist = JSON.parse(localStorage.getItem('saskara_artist_info') || '{}');
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({
    title: '', artwork_url: '', lyrics: '', genre: '', release_date: '',
    description: '', tags: '', composer: '', arranger: '',
  });
  const [saving, setSaving] = useState(false);
  const [artistStats, setArtistStats] = useState(null);

  const fetchStats = async () => {
    try {
      const res = await api.get('/artist-auth/me');
      setArtistStats(res.data);
    } catch (err) {
      console.error(err);
    }
  };
  const [uploading, setUploading] = useState(false);

  const fetchSongs = async () => {
    setLoading(true);
    try {
      const res = await api.get('/songs/mine');
      setSongs(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSongs();
    fetchStats();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('saskara_artist_token');
    localStorage.removeItem('saskara_artist_info');
    navigate('/login');
  };

  const handleArtworkUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('photo', file);
      const res = await api.post('/admin-upload/artist-self-photo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setForm((f) => ({ ...f, artwork_url: res.data.url }));
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload artwork');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const openCreate = () => {
    setForm({ title: '', artwork_url: '', lyrics: '', genre: '', release_date: '', description: '', tags: '', composer: '', arranger: '' });
    setModal(true);
  };

  const submitSong = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post('/songs', form);
      setModal(false);
      await fetchSongs();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload lagu');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="artist-dashboard">
      <nav className="artist-nav">
        <span className="artist-nav__logo">SASKARA<span>RECORD</span></span>
        <div className="artist-nav__right">
          <a href="https://saskararecord.com" className="artist-nav__logout">Beranda</a>
          <Link to="/profile" className="artist-nav__logout" style={{ textDecoration: 'none' }}>Profil Saya</Link>
          <span className="artist-nav__name">{artist.name}</span>
          <button className="artist-nav__logout" onClick={handleLogout}>Logout</button>
        </div>
      </nav>

      <div className="artist-content">
        <div className="artist-header-row">
          <div>
            <p className="artist-greeting">Hai, {artist.name} 👋</p>
            <h1 style={{ marginTop: 4 }}>Lagu Saya</h1>
          </div>
          <button className="btn-primary" onClick={openCreate}>+ Upload Lagu Baru</button>
        </div>

        {artistStats && (() => {
          const checklist = [
            { label: 'Lengkapi bio profil', done: !!(artistStats.bio && artistStats.bio.length > 10), action: '/profile' },
            { label: 'Upload foto profil', done: !!artistStats.photo_url, action: '/profile' },
            { label: 'Tambah link Instagram atau TikTok', done: !!(artistStats.instagram_url || artistStats.tiktok_url), action: '/profile' },
            { label: 'Upload lagu pertama', done: songs.length > 0, action: null },
          ];
          const doneCount = checklist.filter((c) => c.done).length;
          if (doneCount === checklist.length) return null;
          return (
            <div className="onboarding-checklist">
              <div className="onboarding-checklist__header">
                <span>Lengkapi Profil Kamu</span>
                <span className="onboarding-checklist__progress">{doneCount}/{checklist.length}</span>
              </div>
              <div className="onboarding-checklist__bar">
                <div className="onboarding-checklist__bar-fill" style={{ width: `${(doneCount / checklist.length) * 100}%` }} />
              </div>
              <ul className="onboarding-checklist__list">
                {checklist.map((item, i) => (
                  <li key={i} className={item.done ? 'done' : ''}>
                    <span className="onboarding-checklist__icon">{item.done ? '✅' : '⬜'}</span>
                    <span className="onboarding-checklist__text">{item.label}</span>
                    {!item.done && (
                      item.action ? (
                        <Link to={item.action} className="onboarding-checklist__action">Lengkapi →</Link>
                      ) : (
                        <button type="button" className="onboarding-checklist__action-btn" onClick={openCreate}>Upload →</button>
                      )
                    )}
                  </li>
                ))}
              </ul>
            </div>
          );
        })()}
        {artistStats && (
          <div className="stats-summary">
            <div className="stats-summary__item">
              <span className="stats-summary__label">👁 Views Profil</span>
              <span className="stats-summary__value">{artistStats.view_count || 0}</span>
            </div>
            <div className="stats-summary__item">
              <span className="stats-summary__label">❤️ Likes</span>
              <span className="stats-summary__value">{artistStats.like_count || 0}</span>
            </div>
            <div className="stats-summary__item">
              <span className="stats-summary__label">👥 Followers</span>
              <span className="stats-summary__value">{artistStats.follower_count || 0}</span>
            </div>
          </div>
        )}

        {!loading && songs.length > 0 && (
          <div className="earnings-summary">
            <div className="earnings-summary__item">
              <span className="earnings-summary__label">Total Lagu</span>
              <span className="earnings-summary__value">{songs.length}</span>
            </div>
            <div className="earnings-summary__item">
              <span className="earnings-summary__label">Total Estimasi Pendapatan</span>
              <span className="earnings-summary__value earnings-summary__value--gold">
                Rp {songs.reduce((sum, s) => sum + (s.platforms || []).reduce((ps, p) => ps + Number(p.total_earnings || 0), 0), 0).toLocaleString('id-ID')}
              </span>
            </div>
          </div>
        )}

        {loading ? (
          <p style={{ color: '#9A9AA2' }}>Memuat...</p>
        ) : songs.length === 0 ? (
          <p style={{ color: '#9A9AA2' }}>Belum ada lagu. Upload lagu pertamamu!</p>
        ) : (
          <div className="song-grid">
            {songs.map((song) => (
              <div className="song-card" key={song.id}>
                <div className="song-card__artwork">
                  {song.artwork_url ? (
                    <img src={song.artwork_url} alt={song.title} />
                  ) : (
                    <div className="song-card__artwork-fallback" />
                  )}
                </div>
                <div className="song-card__body">
                  <h3>{song.title}</h3>
                  <span className={`song-status song-status--${song.status}`}>
                    {STATUS_LABEL[song.status] || song.status}
                  </span>

                  {song.platforms && song.platforms.length > 0 ? (
                    <div className="song-card__platforms">
                      <p className="song-card__platforms-label">Tersedia di:</p>
                      {song.platforms.map((p, i) => (
                        <div key={i} className="song-card__platform-row">
                          <a href={p.platform_url} target="_blank" rel="noreferrer" className="song-card__platform-badge">
                            {p.platform_name}
                          </a>
                          <span className="song-card__platform-earning">
                            Rp {Number(p.total_earnings || 0).toLocaleString('id-ID')}
                          </span>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="song-card__no-platform">Belum didistribusikan ke platform manapun.</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(false)}>
          <form className="modal-box" onClick={(e) => e.stopPropagation()} onSubmit={submitSong}>
            <h2>Upload Lagu Baru</h2>
            <input
              type="text"
              placeholder="Judul lagu"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              required
            />
            <label style={{ fontSize: 12, color: '#9A9AA2', marginTop: 4 }}>Artwork / Cover Lagu</label>
            <input
              type="url"
              placeholder="URL artwork (atau upload dari perangkat di bawah)"
              value={form.artwork_url}
              onChange={(e) => setForm({ ...form, artwork_url: e.target.value })}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
              <label style={{ display: 'inline-block', fontSize: 13, color: '#C9A66B', border: '1px solid #C9A66B', padding: '6px 14px', borderRadius: 6, cursor: 'pointer' }}>
                {uploading ? 'Mengupload...' : '📁 Upload dari Perangkat'}
                <input type="file" accept="image/jpeg,image/png,image/webp" onChange={handleArtworkUpload} disabled={uploading} style={{ display: 'none' }} />
              </label>
              {form.artwork_url && (
                <div style={{ width: 40, height: 40, borderRadius: 4, overflow: 'hidden', background: '#303034' }}>
                  <img src={form.artwork_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                </div>
              )}
            </div>
            <input
              type="text"
              placeholder="Genre"
              value={form.genre}
              onChange={(e) => setForm({ ...form, genre: e.target.value })}
            />
            <label style={{ fontSize: 12, color: '#9A9AA2', marginTop: 4 }}>Tanggal Rilis Lagu (bukan jadwal publish web)</label>
            <input
              type="date"
              value={form.release_date}
              onChange={(e) => setForm({ ...form, release_date: e.target.value })}
            />
            <input
              type="text"
              placeholder="Pencipta Lagu (Composer)"
              value={form.composer}
              onChange={(e) => setForm({ ...form, composer: e.target.value })}
            />
            <input
              type="text"
              placeholder="Arranger / Pencipta Musik"
              value={form.arranger}
              onChange={(e) => setForm({ ...form, arranger: e.target.value })}
            />
            <input
              type="text"
              placeholder="Tag (pisahkan koma)"
              value={form.tags}
              onChange={(e) => setForm({ ...form, tags: e.target.value })}
            />
            <textarea
              placeholder="Deskripsi singkat"
              rows={2}
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            />
            <textarea
              placeholder="Lirik lagu"
              rows={5}
              value={form.lyrics}
              onChange={(e) => setForm({ ...form, lyrics: e.target.value })}
            />
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={() => setModal(false)}>Batal</button>
              <button type="submit" className="btn-primary" disabled={saving}>
                {saving ? 'Mengirim...' : 'Kirim untuk Review'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
